var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cell py-1 flex items-center justify-center border-gray-200 dark:border-gray-600 whitespace-nowrap min-w-[11rem] text-xs",class:[_vm.background, { 'min-w-[18rem]': _vm.isImportModal }]},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }